<ng-container *transloco="let t">

    <!-- Custom day template -->
    <ng-template #day let-date let-currentMonth="currentMonth">
        <span class="custom-day"  [class.disabled]="isDisabled(date)" [class.faded]="date.month !== currentMonth"
              [class.today]="isToday(date)" [class.range]="isInRange(date)" [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>

    <ng-template #navigationTemplate>
        <div class="calendar-controls py-2 d-flex align-items-center justify-content-between">
            <div class="btn-circle me-2 navigate" (click)="navigatePrevious()"
                 [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                <i class="scale-80 bi bi-chevron-left"></i>
            </div>

            <div class="d-flex justify-content-center">
                <button class="navigator-button" (click)="changeCalendarState(CalendarState.MONTH)"
                        [ngClass]="{'selected': calendarState === CalendarState.MONTH }">
                    {{
                    t("app.common.month." + navigationDate.month)
                    }}
                </button>
                <button class="navigator-button" (click)="changeCalendarState(CalendarState.YEAR)"
                        [ngClass]="{'selected': calendarState === CalendarState.YEAR }">
                    {{ navigationDate.year }}
                </button>
            </div>
            <div class="btn-circle ms-2 navigate" (click)="navigateNext()"
                 [ngStyle]="{'visibility': calendarState === CalendarState.MONTH ? 'hidden' : 'visible'}">
                <i class="scale-80 bi bi-chevron-right"></i>
            </div>
        </div>
    </ng-template>

    <ng-template #yearSelectTemplate>
        <div class="container">
            <div class="row row-cols-3">
                @for (navigation of years;track navigation) {
                <div class="col p-2">
                    <div (click)="!navigation.disabled ? yearSelected($event, (navigation.value)): null"
                         class="picker btn-light"
                         [ngClass]="{'bg-primary text-white': navigationDate.year === navigation.value,
                'disabled': navigation.disabled,
                'current': !(navigationDate.year === navigation.value) && currentDate.getFullYear() === navigation.value}">
                {{ navigation.value }}
                </div>
            </div>
                }
            </div>
        </div>
    </ng-template>


    <ng-template #monthSelectTemplate>
        <div class="container">
            <div class="row row-cols-3">
                @for (navigation of months;track navigation) {
                <div class="col p-2">
                    <div (click)="!navigation.disabled ? monthSelected($event, navigation.value) : null"
                         class="picker btn-light" [ngClass]="{
                'bg-primary text-white': navigationDate.month === navigation.value,
                'disabled': navigation.disabled,
                'current': !(navigationDate.month === navigation.value) &&
                currentDate.getFullYear() === navigationDate.year && currentDate.getMonth()+1 === navigation.value
                }">
                {{ t("app.common.month." + navigation.value) }}
                </div>
            </div>
                }
            </div>
        </div>
    </ng-template>



<div class="container-scroll">
    <!-- Fixed day-of-week header -->
    <div class="header-fixed">
        <div>
            <ng-template [ngTemplateOutlet]="navigationTemplate"></ng-template>
            @if (calendarState === CalendarState.DAY) {
               @if (alignment === 'horizontal'){
            <div class="d-flex">
                <div class="col-6">
                    <ngb-datepicker class="header-calendar"></ngb-datepicker>

                </div>
                <div class="col-6">
                    <ngb-datepicker class="header-calendar"></ngb-datepicker>

                </div>
            </div>

            }
            @else {
            <ngb-datepicker class="header-calendar"></ngb-datepicker>
                }
            }
        </div>

    </div>
        <div class="content-scrollable">
            @if (calendarState === CalendarState.YEAR) {
            <ng-template [ngTemplateOutlet]="yearSelectTemplate"></ng-template>
            }
            @else if (calendarState === CalendarState.MONTH) {
            <ng-template [ngTemplateOutlet]="monthSelectTemplate"></ng-template>
            }
            @else {
            <div class="month-block">
                <ngb-datepicker
                        class="app-calendar"
                        [class.vertical-calendar] = "alignment === 'vertical'"
                        [ngModel]="selectedDate"
                        (ngModelChange)="onDateSelect($event)"
                        [startDate]="navigationDate"
                        [navigation]="'none'"
                        [markDisabled]="markDisabled" #calendar="ngbDatepicker"
                        [dayTemplate]="day"
                        [displayMonths]="isRange ? 2 : 1"
                        [showWeekNumbers]="false"
                        [outsideDays]="'collapsed'">
                </ngb-datepicker>
            </div>
            }
        </div>
</div>
</ng-container>